/**
 * campaign list 相关
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';

export default {
  namespaced: true,
  actions: {
    getAdReportStat(store, data) {
      return request.get(apis.brand.report_stat, data);
    },

    // 获取需要复制的计划信息
    getBrandCopyInfo(store, data) {
      return request.get(apis.brand.copy, data);
    },

    // 获取 brand 列表
    getBrandList(store, data) {
      return request.get(apis.brand.list, data);
    },

    // 更改 brand 状态
    updateBrandStatus(store, data) {
      return request.postForm(apis.brand.update_status, data);
    },

    // 更新实况
    postDeliverVerify(store, data) {
      return request.postForm(apis.brand.deliver_verify, data);
    },
  },
};
